import React from 'react';
import TextField from '@mui/material/TextField';
import styles from './index.module.css';

const TextInput = ({ value = '', onChange, placeholder = '', ariaLabel, ...rest }) => {
  const handleChange = (e) => {
    if (typeof onChange === 'function') onChange(e.target.value);
  };

  return (
    <TextField
      className={styles.input}
      fullWidth
      variant='outlined'
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      inputProps={{ 'aria-label': ariaLabel || placeholder }}
      {...rest}
    />
  );
};

export default TextInput;
